import type { IconSvgObject } from './types';

const SearchCheckIcon: IconSvgObject = [
  ["path", { d: "M17.4922 17.5L21.9922 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.9922 11C19.9922 6.02944 15.9628 2 10.9922 2C6.02163 2 1.99219 6.02944 1.99219 11C1.99219 15.9706 6.02163 20 10.9922 20C15.9628 20 19.9922 15.9706 19.9922 11Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.49219 11.8333C7.49219 11.8333 8.36719 11.8333 9.24219 13.5C9.24219 13.5 12.0216 9.33333 14.4922 8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SearchCheckIcon;
